import { Injectable } from '@angular/core';
import { DDElement } from '../../models/dd-element.model';
import { Identified } from '../../models/identified.model';

@Injectable({
    providedIn: 'root'
})
export class DdSupportService {

    ddElement: DDElement | null = null
    elementSelected: Identified | string | null = null

    clearSelection() {
        this.elementSelected = null
    }

}
